'use client';

import useMounted from '@/components/core/hooks/use-mounted';
import { useLingui } from '@lingui/react';
import React from 'react';

const Datetime: React.FC<{ date: Date; format?: Intl.DateTimeFormatOptions; relative?: Intl.RelativeTimeFormatUnit }> = ({
  date,
  relative,
  format = { dateStyle: 'short', timeStyle: 'short' },
}) => {
  const { i18n } = useLingui();
  const mounted = useMounted();
  if (!mounted) {
    return <span>&nbsp;</span>;
  }
  if (relative) {
    const seconds = Math.ceil((date.getTime() - new Date().getTime()) / 1000);
    const minute = Math.ceil(seconds / 60);
    const hour = Math.ceil(minute / 60);
    const day = Math.ceil(hour / 24);

    const diff = {
      seconds,
      minute,
      hour,
      day,
    } as {
      // eslint-disable-next-line no-unused-vars
      [type in keyof Intl.DateTimeFormatOptions]: number;
    };
    const currentDiff = diff[relative];
    const relativeFormat = new Intl.RelativeTimeFormat(i18n.locale, { numeric: 'auto' });
    if (currentDiff > -7 && currentDiff < 7) {
      return relativeFormat.format(currentDiff, relative);
    }
  }
  return new Intl.DateTimeFormat(i18n.locale, format).format(date);
};

export default Datetime;
